import type { Anchor } from '../quran/anchor';

/**
 * The marker the معلم last placed, for the session in progress.
 *
 * It exists because the two halves live on different screens: the marker is
 * moved on CallScreen (it arrives and leaves over the LiveKit data channel),
 * while passing the turn and closing the session are controls on the معلم's
 * own screen. Those are siblings in the stack, so neither can see the other's
 * state.
 *
 * Deliberately NOT persisted and NOT reactive. It is read once, at the moment
 * the turn moves or the session closes, to record where a student got to —
 * the same reasoning that keeps the marker off Firestore in the first place:
 * a write per word is what this design exists to avoid.
 *
 * Keyed by session so a stale marker from this morning's session cannot be
 * recorded against this afternoon's.
 */
let current: { sessionId: string; anchor: Anchor } | null = null;

export function rememberMarker(sessionId: string, anchor: Anchor): void {
  current = { sessionId, anchor };
}

/** The ayah last marked in THIS session, or undefined if there isn't one. */
export function markedAyah(sessionId: string): { surah: number; ayah: number } | undefined {
  if (!current || current.sessionId !== sessionId) return undefined;
  return { surah: current.anchor.surah, ayah: current.anchor.ayah };
}

export function forgetMarker(): void {
  current = null;
}
